import gql from "graphql-tag";

const getUploadTokenQuery = gql`
  query GetUploadToken($entityName: String) {
    getUploadToken(entityName: $entityName) {
      token
      uploadUrl
    }
  }
`;

export { getUploadTokenQuery };
